import React, { useRef, forwardRef, useImperativeHandle, useEffect } from 'react'
import clsx from 'clsx'
import { CharsCounter } from '../charsCounter'
import { Textarea } from './input.styles'
import { InputProps } from './input.types'
import { COMMENT_LIMIT, DEFAULT_HEIGHT } from './input.constants'

const Input = forwardRef(
  (
    { value, placeholder, readOnly, showCounter = false, onChange, onFocus, onKeyDown }: InputProps,
    ref
  ) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null)

    useImperativeHandle(ref, () => ({
      focus: () => {
        textareaRef?.current?.focus()
      }
    }))

    const isValidValue = Boolean(value?.trim()?.length)
    const tagComponent = showCounter || typeof jest !== 'undefined' ? 'textarea' : 'input'

    const resizeTextarea = (reset = false) => {
      const textarea = textareaRef.current

      if (textarea) {
        textarea.style.cssText = reset
          ? `min-height: ${DEFAULT_HEIGHT}`
          : `min-height: ${textarea.scrollHeight / 16}rem`
      }
    }

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      resizeTextarea()
      onChange(event)
    }

    useEffect(() => {
      if (!isValidValue) {
        resizeTextarea(true)
      }
    }, [value])

    return (
      <>
        <Textarea
          as={tagComponent}
          ref={textareaRef}
          maxLength={COMMENT_LIMIT}
          placeholder={placeholder}
          className={clsx(
            '_text-gray-900 _p-3 _border-0 _w-full _rounded _d-block _overflow-hidden',
            {
              '_pb-5': !!showCounter
            }
          )}
          value={value}
          rows={1}
          readOnly={readOnly}
          hasText={showCounter}
          onChange={handleChange}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
        />

        {showCounter && <CharsCounter value={value} limit={COMMENT_LIMIT} />}
      </>
    )
  }
)

export default Input
